document.addEventListener('DOMContentLoaded', () => {
    // slick default setting

    const heroSwiper = new Swiper('.hero-swiper', {
		slidesPerView: 1,
		loop: true,
		speed: 600,
        fadeEffect: {
			crossFade: true,
		},
		effect: "fade",
        autoplay: {
            delay: 4200,
            disableOnInteraction: false
        }
	});

    const sliderSwiper = new Swiper('.slider-swiper', {
		slidesPerView: 1,
		loop: true,
		speed: 600,
        fadeEffect: {
			crossFade: true,
		},
		effect: "fade",
        navigation: {
			nextEl: ".slider-next",
			prevEl: ".slider-prev",
		},
		a11y: { 
            enabled: true,
            prevSlideMessage: 'Previous Button - PRV',
            nextSlideMessage: 'Next Button - NXT'
        }
	});

    const gallerySwiper = new Swiper('.gallery-swiper', {
		slidesPerView: 1,
		loop: true,
		speed: 600,
        fadeEffect: {
			crossFade: true,
		},
		effect: "fade",
        navigation: {
			nextEl: ".gallery-next",
			prevEl: ".gallery-prev",
		},
		a11y: { 
            enabled: true,
            prevSlideMessage: 'Previous Button - PRV',
            nextSlideMessage: 'Next Button - NXT'
        }
	});

});